import app from 'flarum/forum/app';
import extractText from 'flarum/common/utils/extractText';
import MessageSearchResult from './MessageSearchResult';

/**
 * Finds the member's private messages by what they say. The API only searches
 * the conversations the member is part of, so nobody else's can turn up.
 */
export default class GlobalMessagesSearchSource {
  results = (() => new Map())();
  resource = 'dialog-messages';
  title() {
    return extractText(app.translator.trans('flarum-messages.forum.search_source.heading'));
  }
  isCached(query) {
    return this.results.has(query.toLowerCase());
  }
  async search(query, limit) {
    query = query.toLowerCase();
    this.results.set(query, []);
    return app.store.find('dialog-messages', {
      filter: {
        q: query
      },
      page: {
        limit
      },
      // The conversation's members, to say who it is with.
      include: 'user,dialog.users'
    }).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    return (this.results.get(query) || []).map(message => m(MessageSearchResult, {
      message: message,
      query: query
    }));
  }
  customGrouping() {
    return false;
  }

  /** Messages have no page of their own to list every result on. */
  fullPage() {
    return null;
  }
  gotoItem(id) {
    const message = app.store.getById('dialog-messages', id);
    const dialog = message?.dialog();
    return message && dialog ? app.route.dialog(dialog, message.number()) : null;
  }
}
flarum.reg.add('flarum-messages', 'forum/components/GlobalMessagesSearchSource', GlobalMessagesSearchSource);